import Link from 'next/link';

const faqs = [
  {
    id: 1,
    question: 'Czego potrzebuję aby zacząć?',
    answer:
      'Potrzebujesz kodów, które otrzymasz w postaci naklejek na książki w formacie A6. Ponadto będzie Ci potrzebne konto na portalu oraz kamera z funkcją odczytu kodów QR (na przykład smartfon).',
  },
  {
    id: 2,
    question:
      'Czy skatalogowanie wiąże się z jakimiś dodatkowymi opłatami? Trzeba coś subskrybować?',
    answer:
      "Nie. Książka będzie skatalogowana tak długo, jak będzie posiadać czytelny kod. Kody drukowane są metodą opracowaną przez Gary'ego Starkweathera, która nie pozwoli na wyblaknięcie naszych kodów przez dziesięciolecia.",
  },
  {
    id: 3,
    question: 'Jakie książki mogę katalogować?',
    answer:
      'Obecnie oferta dotyczy książek posiadających numer ISBN 10 lub 13 cyfrowy (zazwyczaj wydane nie wcześniej niż w 1982 roku).',
  },
  {
    id: 4,
    question: 'Jak przebiega katalogowanie?',
    answer:
      "Po przyklejeniu kodu na książkę, należy zeskanować kod czytnikiem QR (np. kamerą w smartfonie), nastepnie otworzyć link, wpisać numer ISBN i kliknąć 'Połącz'.",
  },
  {
    id: 5,
    question: 'Jak mogę przetestować system?',
    answer:
      'Załóż konto a następnie spróbuj znaleźć książkę, która już posiada kod - została sprzedana przez innego użytkownika. Sprawdzisz wtedy jak działa wymiana oraz panel użytkownika. Aby przetestować proces katalogowania należy zakupić pakiet czystych kodów.',
  },
];

export default function FAQBuy() {
  return (
    <>
      {/* FAQ offset */}
      <div className="mx-auto max-w-7xl py-16 px-6 lg:py-20 lg:px-8">
        <div className="lg:grid lg:grid-cols-3 lg:gap-8">
          <div className="space-y-4">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900">Pytania?</h2>
            <p className="text-lg text-gray-500">
              Jeśli masz pytanie ale nie możesz znaleźć tu na nie odpowiedzi
              <Link href="/contact" className="ml-1 font-medium text-teal-600 hover:text-teal-500">
                napisz
              </Link>
              .
            </p>
          </div>
          <div className="mt-12 lg:col-span-2 lg:mt-0">
            <dl className="space-y-12">
              {faqs.map((faq) => (
                <div key={faq.id}>
                  <dt className="text-lg font-medium leading-6 text-gray-900">{faq.question}</dt>
                  <dd className="mt-2 text-base text-gray-500">{faq.answer}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </>
  );
}
